export const V1_RECEIVE_TOUR_OPERATORS = 'V1_RECEIVE_TOUR_OPERATORS'

export default data => {
  return {
    type: V1_RECEIVE_TOUR_OPERATORS,
    data,
  }
}
